import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {Box, Button, Card, CardContent} from "@mui/material";
import { useGetVersOreDTO } from "../gestversore/Services";
import EditVersOre from "../gestversore/EditVersOre";
import AddVersOre from "../gestversore/AddVersOre";
import type { EventClickArg } from "@fullcalendar/core";
import type { MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState } from "material-react-table";

interface CalendarioProps {}

const Calendario: React.FC<CalendarioProps> = () => {
  const [validationErrors, setValidationErrors] = useState<Record<string, string | undefined>>({});
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: 1000 });

  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);

  const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);


  const [nrrel, setNrrel] = useState<string | null>(null);

  const { data: { results = [], count } = {}, isFetching: isFetchingVersOre, isLoading: isLoadingVersOre } =
    useGetVersOreDTO(pagination, columnFilters, globalFilter, sorting);

  const events = results.map((item: any) => ({
    id: `${item.nrrel}`,
    title: `(${item.coddip}) ${item.desprog} ${item.note}`,
    start: new Date(item.datareg), // Ensure correct date format
    allDay: true,
  }));

  // Handle event clicks
  const handleEventClick = (clickInfo: EventClickArg) => {
     const eventId = clickInfo.event.id;
     // console.log("events: ",events);
     // console.log("eventId before: ",eventId);
        setNrrel(eventId);
        if (nrrel) {
          // console.log("nrrel before: ",nrrel);
          setIsDialogEditOpen(true);
        }
  };


  const openAddModal = () => {
        setIsDialogAddOpen(true);
  };

  // // Open dialog when nrrel updates
  // useEffect(() => {
  //   if (nrrel) {
  //     console.log("nrrel before: ",nrrel);
  //     setIsDialogEditOpen(true);
  //   }
  // }, [nrrel]);

useEffect(() => {
  document.querySelectorAll(".fc-button").forEach((button) => {
    (button as HTMLElement).style.backgroundColor = "#0971d9"; // Green background
    (button as HTMLElement).style.color = "white";
  });
}, []);

const handleDatesSet = (dateInfo: any) => {
  // Get the first and last day of the current month
  const currentMonthStart = dateInfo.view.currentStart;
  const currentMonthEnd = dateInfo.view.currentEnd;

  setColumnFilters([
    {
      id: "datareg", // Assuming `datareg` is the column for start date
      value: [currentMonthStart.toISOString(), currentMonthEnd.toISOString()], // Range filter for start and end date of the month
    },
  ]);
};



// console.log(columnFilters);


  return (
    <Box sx={{ mt: "60px" }}>
           {isDialogAddOpen && ( <AddVersOre    onClose={() => {setIsDialogAddOpen(false); }} /> )}
      <Card sx={{ padding: 2, boxShadow: 3, borderRadius: 2 }}>
        <CardContent>
          <Button variant="contained" onClick={openAddModal}>Nuovo</Button>
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                      initialView="dayGridMonth"
                      headerToolbar={{
                        left: "",
                        center: "title",
                        right: "prev,next today dayGridMonth dayGridWeek",
                      }}
            events={events}
            eventClick={handleEventClick}
            editable
            selectable
            eventContent={(arg) => <div style={{ fontSize: "10px", color: "white" }}>{arg.event.title}</div>}
            datesSet={handleDatesSet}
          />
        </CardContent>
      </Card>


      {/*{isDialogEditOpen && nrrel && <EditVersOre id={parseInt(nrrel)} onClose={() => setIsDialogEditOpen(false)} />}*/}

           {isDialogEditOpen && nrrel && (
              <EditVersOre
                id={parseInt(nrrel)}
                isReadOnly={false}
                onClose={() => setIsDialogEditOpen(false)}
              />
            )}




    </Box>
  );
};

export default Calendario;
